import { useState } from 'react';

import classNames from 'classnames';
import { Link, NavLink } from 'react-router-dom';

import { NAVIGATION } from '@/constants/navigation';

import { HelpCircle } from 'lucide-react';
import HowItWorksModal from '../ui/HowItWorksModal';
import CustomConnectButton from '../CustomConnectButton';
import TokenRacingLogo from '../../assets/TokenRacingLogo.png';

const Navbar = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [showHowItWorksModal, setShowHowItWorksModal] = useState(false);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
    // Prevent body scroll when menu is open
    document.body.style.overflow = !isMenuOpen ? 'hidden' : 'unset';
  };

  const closeMenu = () => {
    setIsMenuOpen(false);
    document.body.style.overflow = 'unset';
  };

  const openHowItWorksModal = () => {
    setShowHowItWorksModal(true);
    if (isMenuOpen) {
      closeMenu();
    }
  };

  return (
    <>
      <nav className="border-b border-[#282133]">
        <div className="mx-auto max-w-[1280px]">
          <div className="flex h-16 items-center justify-between gap-6 p-4">
            <div className="flex items-center">
              <Link to="/" className="no-underline">
                <div className="flex items-center">
                  <img src={TokenRacingLogo} alt="TokenRacing" className="h-[45px] w-auto object-contain" />
                </div>
              </Link>
            </div>

            <div className="hidden grow items-center gap-2 xl:flex">
              {NAVIGATION.map(item => (
                <NavLink
                  key={item.to}
                  to={item.to}
                  className={({ isActive }) =>
                    classNames(
                      'relative overflow-hidden rounded-full border border-[#282133] px-4 py-2 text-sm font-medium text-gray-400 hover:bg-[rgba(124,58,237,0.2)] hover:text-white',
                      {
                        'text-white before:pointer-events-none before:absolute before:bottom-[-20px] before:left-[10%] before:h-[43px] before:w-[80%] before:rounded-full before:bg-[radial-gradient(#a75eec,transparent)] before:blur-[10px]':
                          isActive,
                      }
                    )
                  }
                >
                  <span className="z-[1] flex items-center">
                    {item.icon}
                    <span className="ml-2 md:block">{item.text}</span>
                  </span>
                </NavLink>
              ))}
            </div>

            <div
              className={`fixed bottom-0 left-0 right-0 top-16 z-50 transform space-y-2 bg-[#10091C] p-4 transition-all duration-300 ease-in-out xl:hidden ${isMenuOpen ? 'visible translate-x-0 opacity-100' : 'invisible translate-x-full opacity-0'}`}
            >
              {NAVIGATION.map(item => (
                <NavLink
                  key={item.to}
                  to={item.to}
                  className={({ isActive }) =>
                    classNames(
                      'relative flex items-center justify-center gap-1 overflow-hidden rounded-full border border-[#282133] p-4 leading-none',
                      {
                        'text-white before:pointer-events-none before:absolute before:bottom-[-20px] before:left-0 before:h-[56px] before:w-full before:rounded-full before:bg-[radial-gradient(#A75EEC38,transparent)] before:blur-[5px]':
                          isActive,
                        'bg-[#090409] text-[#686868] hover:text-white': !isActive,
                      }
                    )
                  }
                >
                  {item.icon}
                  <span>{item.text}</span>
                </NavLink>
              ))}

              <button
                className="relative flex w-full items-center justify-center gap-1 overflow-hidden rounded-full border border-[#282133] bg-purple-1 p-4 text-sm font-medium leading-none text-white transition-all duration-200"
                onClick={openHowItWorksModal}
              >
                <HelpCircle className="h-5 w-5" />
                <span>How Does It Work</span>
              </button>
            </div>

            <div className="flex items-center gap-2">
              <CustomConnectButton />

              <button
                className="flex items-center gap-2 rounded-lg bg-purple-1 px-3 py-2.5 text-sm font-medium text-white transition-all duration-200 lg:py-2 xl:order-first"
                onClick={openHowItWorksModal}
              >
                <HelpCircle className="h-5 w-5" />
                <span className="hidden lg:inline">How Does It Work</span>
              </button>

              <button
                className="flex cursor-pointer flex-col gap-1.5 rounded-lg border-none bg-transparent p-2 text-white transition-colors duration-200 *:transition hover:bg-white/10 xl:hidden"
                onClick={toggleMenu}
              >
                <span className="sr-only">{isMenuOpen ? 'Close Menu' : 'Open Menu'}</span>
                <span
                  className={classNames('h-[1px] w-5 origin-center bg-white', {
                    'translate-y-2 rotate-45': isMenuOpen,
                    'rotate-0': !isMenuOpen,
                  })}
                ></span>
                <span
                  className={classNames('w- h-[1px] bg-white', {
                    'opacity-0': isMenuOpen,
                  })}
                ></span>
                <span
                  className={classNames('h-[1px] w-3 origin-center bg-white', {
                    'w-5 -translate-y-1.5 -rotate-45': isMenuOpen,
                    'rotate-0': !isMenuOpen,
                  })}
                ></span>
              </button>
            </div>
          </div>
        </div>
      </nav>

      {/* How It Works Modal */}
      <HowItWorksModal isOpen={showHowItWorksModal} onClose={setShowHowItWorksModal} />
    </>
  );
};

export default Navbar;
